import React, { PureComponent } from 'react'
import classnames from 'classnames'

import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import AddAPhoto from '@material-ui/icons/AddAPhoto'
import DeleteIcon from '@material-ui/icons/Delete'

import { getFile } from '../services/fetcher'

import './PhotoHeader.css'

const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i

export default class PhotoHeader extends PureComponent {
  uploadPhoto = async file => {
    const { snackbar, uploadPhoto } = this.props
    if (!allowedExtensions.exec(file.name)) {
      snackbar(
        'Veuillez choisir un fichier valide (.jpg, .jpeg, .png)',
        'error'
      )
    } else {
      uploadPhoto(file)
    }
  }

  cleanFile = () => {
    const { deletePhoto } = this.props
    var fileinput = document.getElementById('sp-photoheader--upload-file')
    fileinput.value = ''
    deletePhoto()
  }

  renderUploadFile() {
    const { photo, disabled } = this.props

    const classes = classnames('sp-photoheader--upload-group', {
      'sp-photoheader--upload-group_int': photo === undefined || photo === ''
    })
    return (
      <div className={classes}>
        <AddAPhoto className="sp-photoheader--uploadicon" />
        <input
          accept="image/*"
          id="sp-photoheader--upload-file"
          type="file"
          onChange={e => {
            if (e.target.files[0]) {
              this.uploadPhoto(e.target.files[0])
            }
          }}
        />
        <label
          className="sp-photoheader--uploadiconlabel"
          htmlFor="sp-photoheader--upload-file"
        >
          <Button variant="contained" component="div" disabled={disabled}>
            {photo === undefined || photo === ''
              ? 'Ajouter une photo...'
              : 'Modifier'}
          </Button>
          {photo !== undefined &&
            photo !== '' && (
              <Button
                variant="fab"
                mini
                className="sp-photoheader--deletefile"
                onClick={this.cleanFile}
              >
                <DeleteIcon style={{ fontSize: 18 }} />
              </Button>
            )}
        </label>
      </div>
    )
  }
  render() {
    const { photo, path, randomSuffix } = this.props
    return (
      <div className="sp-cardheader">
        {photo && (
          <CardMedia
            component="img"
            className="sp-photoheader--photo"
            image={getFile(`${path}/${photo}?${randomSuffix}`)}
            title="Photo de la catégorie"
          />
        )}
        {this.renderUploadFile()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components-utils/PhotoHeader.js